export default "__VITE_ASSET__482dc964__"